import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import { CustomHttpClientService } from './custom-http-client.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class BuildingsService {

  url = environment.apiUrl;

  // Connects to backend , makes REST calls for CRUD operations done in the backend
  // The method names are self-explanatory
  // Parameters are passed from angularjs component
  constructor(private http: CustomHttpClientService) {}

  getAllBuildingsByUserId(userId: string): Observable<any> {
    return this.http.get<any>(`${this.url}users/${userId}/buildings`);
  }

  getAllBuildingsByUser(userId: any): Observable<any> {
    return this.http.get<any>(this.url + 'users/' + userId + '/builds');
  }

  getAllBuildingAlerts(userId: any):Observable<any>{
    return this.http.get<any>(this.url + 'user/'+ userId + '/building/alerts');
  }

  getAllUnreadAlerts(userId: any, buildingId: any):Observable<any>{
    return this.http.get<any>(this.url + 'user/'+ userId + '/building/'+buildingId + '/alerts/unread');
  }

  getLatestBuildingAlerts(userId: any):Observable<any>{
    return this.http.get<any>(this.url + 'user/' + userId + '/building/alerts/latest');
  }

  getLatestBuildingAlertsByBuildingId(buildingId: any):Observable<any>{
    return this.http.get<any>(this.url + 'user/building/'+ buildingId +'/alerts/latest');
  }

  saveBuildingAlert(data: any):Observable<any>{
    return this.http.post<any>(this.url + 'buildings/alerts', data);
  }

  updateBuildingAlert(data: any):Observable<any>{
    return this.http.put<any>(this.url + 'buildings/alerts', data);
  }

  getAllBuildingAlertsByBuiildingId(buildingId: any):Observable<any>{
    return this.http.get<any>(this.url + 'building/' + buildingId + '/alerts' );
  }

  getAllBuildingAlertsByBuiildingIds(buildingIds: any, userId: any):Observable<any>{
    console.log('Service filtered IDs : ',buildingIds);
    return this.http.post<any>(this.url + 'building/alerts' , {building: buildingIds, userId: userId});
  }

  deleteAlert(alertId: any):Observable<any>{
    return this.http.delete<any>(this.url + 'alert/' + alertId);
  }

  getById(buildingId: any):Observable<any>{
    return this.http.get<any>(this.url + 'building/' + buildingId);
  }

  updateBuildingById(building: any):Observable<any>{
    let data = JSON.stringify(building);
    let formData = new FormData();
    formData.append('building', data)
    return this.http.put<any>(this.url + 'building/', formData);
  }

  updateUnreadAlertCount (userId:any, buildingId: any):Observable<any> {
    return this.http.put<any>(this.url + 'user/'+userId+'/building/' +buildingId+'/alerts/unread', {id: userId});
  }


  uploadBuildingCoverPhoto(file: any): Observable<any> {
    // Create a FormData object to send files and other data
    const formData: FormData = new FormData();
    formData.append('id', file.id);
    formData.append('image', file.image || '');
    // Send the PUT request using HttpClient
    return this.http.put<any>(`${this.url}building/uploadCoverPhoto`, formData)
      .pipe(
        catchError(error => {
          console.error('Error uploading cover photo:', error);
          return throwError(error); // Return observable with error
        })
      );
  }

  removeCoverPhoto(data: any): Observable<any> {
    return this.http.put<any>(`${this.url}building/removeCoverPhoto`, data)
      .pipe(
        catchError(error => {
          console.error('Error removing cover photo:', error);
          return throwError(error);  // Return an observable with the error
        })
      );
  }
}
